/**
 * Home component
 *
 * The section at the top of the page to display image of your
 * choice, name and title that describes your career focus.
 */

import React from "react";
import PropTypes from "prop-types";

/**
 * Home background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "url:../images/woman-with-tablet.jpg";

const imageAltText = "Engineer working with a tablet in a modern office";

const Home = ({ name = "", title = "" }) => {
  return (
    <section id="home" className="hero-section min-height">
      <img className="background hero-background" src={image} alt={imageAltText} />
      <div className="hero-overlay" aria-hidden="true" />
      <div className="hero-content">
        <p className="eyebrow">Software and AI Engineer</p>
        <h1>{name}</h1>
        <h2>{title}</h2>
        <p className="hero-description">
          I build AI-powered solutions that turn complex data into simple, reliable tools.
          <br />
          From model development to clean interfaces people can actually use.
        </p>
        <div className="hero-actions">
          <a href="#portfolio" className="button button-primary">
            Explore Projects
          </a>
          <a href="#about" className="button button-ghost">
            How I Build
          </a>
        </div>
        <div className="hero-stats">
          <div className="stat-card">
            <span className="stat-value">4+</span>
            <span className="stat-label">Production AI Integrations</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">10+</span>
            <span className="stat-label">Projects</span>
          </div>
        </div>
      </div>
    </section>
  );
};

Home.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Home;
